import React from 'react';
import { Icon } from 'antd';
import { bool, func, object } from 'prop-types';

import { Tooltip } from '../popovers';
import ColoredLabel from '../colored-label';
import { Wrapper, Header, ButtonS, Client, LabelWrapper } from './styled-components';

const RequestClients = ({
  request: { source: { color, title }, contacts, subject },
  onToggleShowContacts,
  isShowContacts,
}) => (
  <Wrapper
    {...{ isShowContacts }}
  >
    <Header>
      <LabelWrapper>
        <Tooltip title={subject}>
          <span style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
          >
            {subject}
          </span>
        </Tooltip>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ColoredLabel
            {...{ color, title }}
            style={{ maxWidth: '150px' }}
          />
        </div>
      </LabelWrapper>
    </Header>
    {contacts.length > 2 && (
      <ButtonS
        type="primary"
        onClick={onToggleShowContacts}
      >
        <span>Show {isShowContacts ? 'less' : 'more'} ({contacts.length})</span>
        <Icon type={isShowContacts ? 'caret-up' : 'caret-down'} />
      </ButtonS>
    )}
    {[...(isShowContacts
      ? contacts
      : contacts.slice(0, 2))].map(({ fullName, emails, _id }) =>
      (
        <Client key={_id}>
          <b>{fullName}</b>
          <span>{emails[0]}</span>
        </Client>
      ))}
  </Wrapper>
);

RequestClients.propTypes = {
  request: object.isRequired,
  isShowContacts: bool.isRequired,
  onToggleShowContacts: func.isRequired,
};

export default RequestClients;



// WEBPACK FOOTER //
// ./src/components/request-clients/index.js